import { useQuery } from 'react-query';
import { api } from 'src/api/axios';

export const useListOrderStatus = () =>
  useQuery(['listOrderStatus'], async () => {
    const res = await api.get(`/api/cms/order/status`);
    return res.data.data;
  });
